/* theme-listing.js — collection and search listings only.
   Filtering, sorting and pagination through Shopify's Section Rendering API, so
   the markup still comes from the section template. Loaded by
   sections/main-collection.liquid and sections/main-search.liquid, which keeps
   it off every other page. */
(function () {
  'use strict';

  if (window.__tsListingLoaded) return;
  window.__tsListingLoaded = true;

  function announce(msg) {
    var live = document.querySelector('[data-ts-live]');
    if (!live || !msg) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = msg; }, 60);
  }

  function filterOpen(open) {
    if (window.TechStore && typeof window.TechStore.filterOpen === 'function') {
      window.TechStore.filterOpen(open);
    }
  }
  function reinitFilters() {
    if (window.TechStore && typeof window.TechStore.initFilters === 'function') window.TechStore.initFilters();
    if (window.TechStore && typeof window.TechStore.initFilterGroups === 'function') window.TechStore.initFilterGroups();
    if (window.TechStore && typeof window.TechStore.fadeImages === 'function') window.TechStore.fadeImages(document);
  }

  /* ---------- listing: filter, sort and paginate without a full reload ----------
     Uses Shopify's Section Rendering API, so the filtered markup still comes from
     main-collection.liquid / main-search.liquid — there is no second, divergent
     client-side template to keep in sync. Every entry point is a real link or a
     real form, so this is enhancement only: with JavaScript off the same URLs
     still work. */
  var listingAbort = null;

  function listingRoot() { return document.querySelector('[data-ts-listing]'); }

  function listingBusy(root, busy) {
    root.setAttribute('aria-busy', busy ? 'true' : 'false');
    root.style.opacity = busy ? '.55' : '';
    root.style.pointerEvents = busy ? 'none' : '';
  }

  function renderListing(url, push) {
    var root = listingRoot();
    if (!root) { window.location.href = url; return; }
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) { window.location.href = url; return; }

    var target = new URL(url, window.location.origin);
    var fetchUrl = new URL(target.toString());
    fetchUrl.searchParams.set('section_id', sectionId);

    if (listingAbort) listingAbort.abort();
    listingAbort = ('AbortController' in window) ? new AbortController() : null;
    listingBusy(root, true);

    fetch(fetchUrl.toString(), listingAbort ? { signal: listingAbort.signal } : undefined)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) { window.location.href = url; return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-ts-listing]');
        if (!fresh) { window.location.href = url; return; }
        var wasOpen = !!root.querySelector('[data-ts-filter-col].is-open');
        root.innerHTML = fresh.innerHTML;
        listingBusy(root, false);
        /* The filter panel lives inside the swapped markup, so re-apply its open
           state and re-bind the show-more / facet-search controls. */
        if (wasOpen) filterOpen(true);
        reinitFilters();
        if (push !== false) window.history.pushState({ tsListing: true }, '', target.toString());
        var count = root.querySelector('[data-ts-result-count]');
        if (count) announce(count.textContent.trim());
        var anchor = document.getElementById('ts-products');
        if (anchor && window.innerWidth <= 980) anchor.scrollIntoView({ block: 'start' });
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = url;
      });
  }

  function isListingLink(a) {
    if (!a || !listingRoot()) return false;
    if (!listingRoot().contains(a)) return false;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return false;
    if (a.target === '_blank' || a.hasAttribute('download')) return false;
    /* Only controls that change the listing, never a product card. */
    return !!a.closest('.ts-filter-opt, .ts-filter-chip, .ts-filter-cat, .ts-pagination, [data-ts-filters], [data-ts-clear-all]');
  }

  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    var a = e.target.closest('a[href]');
    if (!isListingLink(a)) return;
    e.preventDefault();
    renderListing(a.href, true);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('.ts-sortbar-form, [data-ts-listing] form[method="get"]')) return;
    var root = listingRoot();
    if (!root || !root.contains(form)) return;
    e.preventDefault();
    var action = form.getAttribute('action') || window.location.pathname;
    var qs = new URLSearchParams(new FormData(form)).toString();
    renderListing(action + (qs ? '?' + qs : ''), true);
  });

  /* F13: the select posts its own form; the noscript submit button covers no-JS. */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-ts-sort]');
    if (!sel || !sel.form) return;
    if (typeof sel.form.requestSubmit === 'function') sel.form.requestSubmit();
    else sel.form.submit();
  });

  window.addEventListener('popstate', function (e) {
    if (!listingRoot()) return;
    if (!e.state || !e.state.tsListing) return;
    renderListing(window.location.href, false);
  });


})();
